import { replaceData } from '../common';
import { getValueFromObjects } from '../api/common';

/**
 * Check conditions.
 * @param (Array) conditions
 * @param (Object) userData
 * @return {boolean}
 */
export const checkConditions = (conditions, userData) => {
  if (typeof conditions === 'boolean') {
    return conditions;
  }

  return !conditions || conditions.reduce((result, condition) => {
    if (!result) {
      return result;
    }
    try {
      // eslint-disable-next-line
      return result && eval(replaceData(condition, userData));
    } catch (e) {
      // eslint-disable-next-line
      console.warn('checkConditions failed:', condition, e);
      return false;
    }
  }, true);
};

/**
 * Validate coverage code.
 * @param  (string) coverageCode
 * @param  (Object) initialValues
 * @param  (Object) userData
 * @return {boolean}
 */
export const validateCoverageCode = (coverage, initialValues, userData) => {
  if (Object.hasOwnProperty.call(coverage, 'conditions')) {
    if (!checkConditions(coverage.conditions, userData)) {
      return false;
    }
  }

  if (Object.hasOwnProperty.call(initialValues, 'coverageList')) {
    const { coverageList } = initialValues;
    if (coverageList[coverage.code] && coverageList[coverage.code].conditions) {
      const { conditions } = coverageList[coverage.code];
      return checkConditions(conditions, userData);
    } else if (!coverageList[coverage.code]) {
      return false;
    }
  }

  return true;
};

/**
 * Set flag on the coverage code.
 * @param Object formParams
 * @param string coverageCode
 * @return {Object}
 */
export const setCoverageCodeFormParams = (formParams, coverageCode) => {
  const newFormParams = formParams;
  newFormParams.values[coverageCode] =
    formParams.values.coverageCodes ?
      formParams.values.coverageCodes.indexOf(coverageCode) !== -1 :
      false;

  return newFormParams;
};

export const getBaseCoverage = (element, initialValues, userData, params) => {
  if (element.calculatePrice === false) {
    return undefined;
  }

  const coverages = element.coverages.filter(coverage => {
    return validateCoverageCode(coverage, initialValues, userData);
  });

  const newMappedParams = {
    coverageCodes: coverages.map(e => e.code),
    packageId: element.id,
    packageText: element.packageName,
  };

  if (params.coverageCodes) {
    newMappedParams.coverageCodes = [...newMappedParams.coverageCodes, ...params.coverageCodes]
      .filter((item, pos, self) => self.indexOf(item) === pos);
  }
  return newMappedParams;
};

/**
 * Returns an array of packages and the applicable coverages.
 * @param  {object} state   The current state.
 * @return {array}          Array of object containing the packages and
 *                          the applicable coverages.
 */
export const getPackagesWithCoverage = (state, params) => {
  const { section: { packageData: { initialValues } }, userData } = state;
  const packagesWithCoverage = [];

  if (Object.hasOwnProperty.call(initialValues, 'packages')) {
    initialValues.packages.forEach((element) => {
      const packageDisplay = getPackageDisplay(element, userData);
      const newMappedParams = getBaseCoverage(element, initialValues, userData, params);
      const afbestillingParam = getValueFromObjects('afbestilling', {}, params);
      const afbestilling = getValueFromObjects('afbestilling-travel', {}, userData);
      if (((afbestillingParam && afbestillingParam === 'Afbestilling') ||
        (afbestilling && afbestilling === 'Afbestilling')) &&
        (!newMappedParams.coverageCodes.includes('Å2AB'))) {
        newMappedParams.coverageCodes = [...newMappedParams.coverageCodes, 'Å2AB'];
      }
      const aktivFerieParam = getValueFromObjects('aktivFerie', {}, params);
      const aktivFerie = getValueFromObjects('aktiv-ferie-travel', {}, userData);
      if (((aktivFerieParam && aktivFerieParam === 'Ødelagt aktiv rejse') ||
        (aktivFerie && aktivFerie === 'Ødelagt aktiv rejse')) &&
        (!newMappedParams.coverageCodes.includes('SD27'))) {
        newMappedParams.coverageCodes = [...newMappedParams.coverageCodes, 'SD27'];
      }
      if(packageDisplay) {
        packagesWithCoverage.push(newMappedParams);
      }
    });
  }

  return packagesWithCoverage;
};

/**
 * Returns an array of packages.
 * @param  {object} state   The current state.
 * @return {array}          Array of object containing the packages and
 *                          the applicable coverages.
 */
export const getBasePackages = (state, params) => {
  const { section: { packageData: { initialValues } }, userData } = state;
  const packages = [];
  if (Object.hasOwnProperty.call(initialValues, 'packages')) {
    initialValues.packages.forEach((element) => {
      const newMappedParams = getBaseCoverage(element, initialValues, userData, params);
      packages.push(newMappedParams);
    });
  }
  return packages;
};
/**
 * Validate product package.
 * @param  (Object) packages
 * @param  (Object) userData
 * @return {boolean}
 */
export const getPackageDisplay = (packages,  userData) => {
  if (Object.hasOwnProperty.call(packages, 'conditions')) {
    if (!checkConditions(packages.conditions, userData)) {
      return false;
    }
  }

  return true;
};